import moment from "moment"

export const convertTime = (time, format) => {
  switch (format) {
    case "long":
      return moment(time).format("dddd MM/DD/YYYY HH:mm");
    case "date":
      return moment(time).utc(true).format("MM/DD/YYYY");
    default:
      return moment(time).utc(true).format(format);
  }
}